
export const CkeditorConfig = { removePlugins: 'elementspath'};

// export const CkeditorConfig = { removePlugins: 'elementspath', extraPlugins:['mathjax', 'ckeditor_wiris'],
// mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
// height: 320,
// removeButtons: 'PasteFromWord',
// };

export enum QuestionTypeEnum {
  Matrix = 'Choice Matrix',
  Descriptive = 'Descriptive',
  MultipleChoice = 'Multiple choice',
  Survey = 'Survey',
  FillInTheBlank = 'Fill in the blanks',
  MatchOrder = 'Match & order',
  optionScoring = 'Multiple choice options',
  optionScoring_Matrix = 'Choice Matrix scoring options',
  degree180360 = '180-360 degree'
}

export enum QuestionSubTypeEnum {
  Matrix = 'Matrix Single Choice',
  Descriptive = 'Text',
  MultipleChoiceOptions = 'Multiple Options',
  MultipleChoiceStandard = 'Standard',
  MultipleChoiceYesOrNo = 'Yes or No',
  SurveySingleChoice = 'Single choice',
  SurveyMultiResponse = 'Multi response',
  SurveyShortAnswer = 'Short answer',
  SurveyLikeDislike = 'Like dislike',
  SurveyStarRating = 'Star rating',
  SurveyNumberRating = 'Number rating',
  FillInTheBlanks = 'Text',
  optionScoring_standard = 'Standard with scoring on options',
  optionScoring_multiple = 'Multiple Options with scoring on options',
  optionScoring_trueandFalse = 'Yes or No with scoring on options',
  optionScoring_Matrix = 'Matrix Single Choice with scoring on options',
  degrees180360_standard = 'Standard with scoring on 180-360 degree',
  degrees180360_multi = 'Multiple Options with scoring on 180-360 degree',
  degrees180360_truefalse = 'Yes or No with scoring on 180-360 degree'
}

export enum QuestionSubTypeIdEnum {
  MultipleChoiceOptions = 2, // multiple response
  Matrix = 12,
  Descriptive = 9, // free text
  MultipleChoiceStandard = 1, // single choice
  MultipleChoiceYesOrNo = 3, // true false
  SurveySingleChoice = 13,
  SurveyMultiResponse = 14,
  SurveyShortAnswer = 15,
  SurveyLikeDislike = 16,
  SurveyStarRating = 17,
  SurveyNumberRating = 18,
  FillInTheBlanks = 7, // fill in the blank
  MatchOrder = 19,
  scoringType_MultipleChoiceStandard = 20,
  scoringType_MultipleChoiceOptions = 21,
  scoringType_MultipleChoiceYesOrNo = 22,
  scoringType_Matrix = 23,
  style_MultipleChoiceStandard = 24,
  style_MultipleChoiceOptions = 25,
  style_MultipleChoiceYesOrNo = 26,
  HotspotSingleChoice = 27,
  HotspotMultiChoice = 28,
}

export enum QuestionTypeIdEnum {
  MatchOrder = 3,
  MultipleChoiceOptions = 1,
  MultipleChoiceStandard = 1,
  MultipleChoiceYesOrNo = 1,
  Matrix = 7,
  Descriptive = 4,
  SurveyMultiResponse = 5,
  SurveySingleChoice = 5,
  SurveyShortAnswer = 5,
  SurveyStarRating = 5,
  SurveyNumberRating = 5,
  SurveyLikeDislike = 5,
  FillInTheBlanks = 2,
  multichoice_score_option = 8,
  Matrix_score_option = 9,
  styleType_options = 10,
  Hotspot = 11
}

export enum ScoringTypeEnum {
  OnQuestion = 1,
  OnOption = 2,
  On180360Degree = 3,
}

export enum ScoringTypeNameEnum {
  OnQuestion = 'Question Scoring',
  OnOption = 'Scaler Survey Scoring',
  On180360Degree = 'DISC Style Scoring',
}

export enum ScoringTypeName1 {
  OnQuestion = 'En cuestión',
  OnOption = 'Puntuación de la encuesta a escala',
  On180360Degree = 'Puntuación estilo DISC',
}

export const counterTime = {
  counter : 300,
}

export enum ItemStatusEnum {
  Published = 1,
  Unpublished = 2,
}
